<template>
  <div class="pb-0 mb-0">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">REPORTE RECAUDACIÓN TOTAL POR SEDE. V8</h4>
    <p class="text-center blue--text">El convenio no afecta a este reporte.</p>

    <v-row dense class="ml-2">
      <v-col cols="2">
        <v-combobox v-model="filtros.gestion" :items="gestiones" label="Gestion" :disabled="loading" hide-details
          outlined dense></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox v-model="filtros.mes" :items="meses" label="Mes" :disabled="loading" hide-details outlined
          dense></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox v-if="$store.state.CARGO.id != 25 && $store.state.CARGO.id != 15 && $store.state.CARGO.id != 3"
          v-model="filtros.unidad" :items="unidades" label="Sede" :disabled="loadingunidades || loading"
          :loading="loadingunidades" hide-details outlined dense></v-combobox>
        <span v-else-if="filtros.unidad" class="mt-2 pt-2">
          {{ filtros.unidad.nombre }}
        </span>
      </v-col>
      <v-col cols="3">
        <v-switch v-model="omit_filtro" :disabled="loading" label="Mostrar total" dense hide-details
          title="Omitir el filtro por convenio y mostrar todo." class="mb-4"></v-switch>
      </v-col>
      <v-col cols="3">
        <v-switch v-model="agruparOtrosIngresos" :disabled="loading" label="Agrupar Otros Ingresos" dense hide-details
          title="Agrupar Otros Ingresos" class="mb-4"></v-switch>
      </v-col>
    </v-row>

    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <v-progress-linear indeterminate v-if="loading" class="mt-2" />
    <!-- {{ headersData }} -->
    <!-- {{ structuredData }} -->
    <button :disabled="$store.state.isonlyread" v-show="structuredData.length > 0" class="btn btn-sm btn-link"
      @click="tableToExcel('table', 'Lorem Table')">
      <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL.
    </button>

    <div class="table-responsive xtablefixed" style="height: 71vh">
      <table class="table-hover" ref="table">
        <thead class="text-center green darken-4">
          <tr class="white--text">
            <th class="text-center" rowspan="4">Programas</th>
            <th class="text-center" rowspan="4">Codigo</th>

            <!-- <th :colspan="100">Recaudado</th> :colspan="hc.pagos.length" -->
          </tr>
          <tr class="white--text">
            <!-- <th v-for="(hc, ind) in headersData" :key="ind" :colspan="hc.lengthLevel1" class="">
              {{ hc.recibo_asignacion }}
            </th> -->
            <th v-for="(hc, ind) in headersData" :key="ind"
              :colspan="hc.recibo_asignacion === 'otros ingresos' && agruparOtrosIngresos ? 1 : hc.lengthLevel1 + hc.conceptos.length" class="">
              {{ hc.recibo_asignacion }}
            </th>

            <th rowspan="3">Total</th>
          </tr>
          <!-- <tr class="white--text">
            <template v-for="hc in headersData">
              <th v-for="hp in hc.conceptos" :key="hp.concepto" :colspan="hc.lengthLevel2" class="">{{ hp.concepto }}</th>
            </template>
</tr> -->
          <tr class="white--text">
            <template v-for="(hc, i) in headersData">
              <th v-if="hc.recibo_asignacion === 'otros ingresos' && agruparOtrosIngresos" :key="'otros-' + i" :colspan="1">
                Otros Ingresos
              </th>

              <!-- Caso normal, recorriendo conceptos -->
              <template v-else>
                <th v-for="(hp, j) in hc.conceptos" :key="'hp-' + i + '-' + j"
                  :colspan="hp.estado_recibos_asignacion.length + 1">
                  {{ hp.concepto.split('|')[0] }}
                </th>
              </template>
              <!-- <th v-for="(hp, j) in hc.conceptos" :key="'hp-' + i + '-' + j"
                :colspan="hp.estado_recibos_asignacion.length">
                {{ hp.concepto.split('|')[0] }}
              </th> -->
            </template>


          </tr>
          <!-- <tr class="white--text">
            <template v-for="hc in headersData">
              <template v-for="hp in hc.conceptos">
              <th v-for="he in hp.estado_recibos_asignacion" :key="he"  class="">{{ he }}</th>
              </template>
            </template>
          </tr> -->
          <!-- NIVEL 3 -->
          <!-- <tr class="white--text">
            <template v-for="(hc, i) in headersData">
              <template v-for="(hp, j) in hc.conceptos">
                <th v-for="(he, k) in hp.estado_recibos_asignacion" :key="'he-' + i + '-' + j + '-' + k">
                  {{ he }}
                </th>
              </template>
            </template>
          </tr> -->
          <tr class="white--text">
            <template v-for="(hc, i) in headersData">
              <template v-if="hc.recibo_asignacion === 'otros ingresos' && agruparOtrosIngresos">
                <th :key="'otros-solo' + i" :colspan="1">
                  Otros Ingresos
                </th>
              </template>
              <!-- Caso normal, recorriendo conceptos -->
              <template v-else>
                <template v-for="(hp, j) in hc.conceptos">
                  <th v-for="(he, k) in hp.estado_recibos_asignacion" :key="'he-' + i + '-' + j + '-' + k">
                    {{ he }}
                  </th>
                  <th :key="'total-concepto-hdr-' + i + '-' + j" style="background:#2e7d32; border-left: 2px solid #fff">
                    Total {{ hp.concepto.split('|')[0] }}
                  </th>
                </template>
              </template>

            </template>
          </tr>

        </thead>


        <tbody class="text-right">
          <tr v-for="(row, rIndex) in structuredData" :key="rIndex">
            <!-- COLUMNA FIJA: PROGRAMA -->
            <td class="text-left">
              <b>{{ rIndex + 1 }}.-</b>{{ row.sede.nombre_compuesto }}
            </td>

            <!-- COLUMNA FIJA: CÓDIGO -->
            <td class="text-center">
              {{ row.sede.programa_id }}
            </td>

            <!-- COLUMNAS DINÁMICAS EXACTAMENTE COMO EL HEADER -->
            <template v-for="(hc, i) in headersData">
              <template v-if="hc.recibo_asignacion === 'otros ingresos' && agruparOtrosIngresos">
                <th :key="'cell-otros-solo' + i" :colspan="1">
                {{ getMontoOtrosIngresos(row.recaudaciones) }}
                  
                </th>
              </template>
              <!-- Caso normal, recorriendo conceptos -->
              <template v-else>
                <template v-for="(hp, j) in hc.conceptos">
                  <td v-for="(he, k) in hp.estado_recibos_asignacion"
                    :key="'cell-' + rIndex + '-' + i + '-' + j + '-' + k">
                    {{
                      getMontoCelda(
                        row.recaudaciones,
                        hc.recibo_asignacion,
                        hp.concepto,
                        he
                      )
                    }}
                  </td>
                  <td :key="'cell-tot-' + rIndex + '-' + i + '-' + j"
                    class="font-weight-bold"
                    style="border-left: 2px solid #ccc; background: #f1f8e9">
                    {{ getTotalConcepto(row.recaudaciones, hc.recibo_asignacion, hp.concepto) }}
                  </td>
                </template>
              </template>


              <!-- <template v-for="(hp, j) in hc.conceptos">
                

                <td v-for="(he, k) in hp.estado_recibos_asignacion"
                  :key="'cell-' + rIndex + '-' + i + '-' + j + '-' + k">
                  {{
                    getMontoCelda(
                      row.recaudaciones,
                      hc.recibo_asignacion,
                      hp.concepto,
                      he
                    )
                  }}
                </td>


              </template> -->
            </template>
            <td class="font-weight-bold">
              {{ getTotalFila(row.recaudaciones) }}
            </td>
          </tr>
          <!-- <tr class="text-right green darken-4">
            <td style="background: #196391; color: white" colspan="2" class="text-right">TOTAL</td>
            <td v-for="(t, ind2) in totales" :key="ind2" style="color: white !important">{{ parsecomas(t.monto) }}</td>
          </tr> -->
          <tr class="green darken-4 white--text font-weight-bold">
            <td colspan="2" style="background: #196391; color: white" class="text-right">TOTAL GENERAL</td>

            <template v-for="(hc, i) in headersData">
            <template v-if="hc.recibo_asignacion === 'otros ingresos' && agruparOtrosIngresos">
                <th :key="'cell-otros-total' + i" :colspan="1">
                {{ getMontoTotalOtrosIngresos() }}                  
                </th>
              </template>
              <!-- Caso normal, recorriendo conceptos -->
              <template v-else>
                <template v-for="(hp, j) in hc.conceptos">
                  <td v-for="(he, k) in hp.estado_recibos_asignacion" :key="'total-' + i + '-' + j + '-' + k">
                    {{ getTotalColumna(hc.recibo_asignacion, hp.concepto, he) }}
                  </td>
                  <td :key="'total-concepto-' + i + '-' + j"
                    class="font-weight-bold"
                    style="border-left: 2px solid #a5d6a7; background: #1b5e20">
                    {{ getTotalConceptoColumna(hc.recibo_asignacion, hp.concepto) }}
                  </td>
                </template>
              </template>
              <!-- <template v-for="(hp, j) in hc.conceptos">
                <td v-for="(he, k) in hp.estado_recibos_asignacion" :key="'total-' + i + '-' + j + '-' + k">
                  {{ getTotalColumna(hc.recibo_asignacion, hp.concepto, he) }}
                </td>
              </template> -->
            </template>

            <!-- TOTAL GENERAL FINAL -->
            <td>
              {{
                parsecomas(
                  structuredData.reduce((acc, row) => {
                    row.recaudaciones.forEach(r => {
                      r.pagos.forEach(p => acc += Number(p.monto));
                    });
                    return acc;
                  }, 0)
                )
              }}
            </td>
          </tr>
        </tbody>

        <!-- <tbody class="text-right">
          <tr class="" v-for="(d, ind) in datos" :key="ind">
            <td class="text-left">
              <b>{{ ind + 1 }}.- </b> {{ d.sede.programa_nombre }}
            </td>
            <template v-for="r in d.recaudaciones">
              <td v-for="p in r.pagos" :key="p.rowkey + ind">{{ parsecomas(p.monto) }}</td>
            </template>
            <td class="text-left">{{ parsecomas(d.xtotal_row) }}</td>
          </tr>
          <tr class="text-right green darken-4">
            <td style="background: #196391; color: white" class="text-right">TOTAL</td>
            <td v-for="(t, ind2) in totales" :key="ind2" style="color: white !important">{{ parsecomas(t.monto) }}</td>
          </tr>
        </tbody> -->
      </table>
    </div>



    <!-- <div>
      <AAsignacionTablaRtxs ref="asignacionestablar" v-on:dataloaded="dataloaded" />
    </div> -->
  </div>
</template>
<style lang="css">
@import url('../components/stilo/recaudaciones.css');
</style>


<script>
// import AAsignacionTablaRtxs from '@/components/AAsignacionTablartxs.vue';
import gql from 'graphql-tag';
import xaxios from '@/xaxios';


export default {
  data() {
    return {
      // EXCEL
      uri: 'data:application/vnd.ms-excel;base64,',
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      // END EXCEL
      headersData: [],
      structuredData: [],
      msg: '',
      loading: false,
      loadingunidades: false,
      gestiones: [2024, 2023, 2022, 2021, 2020, 2019, 2018],
      meses: [
        { id: 1, text: 'Enero' },
        { id: 2, text: 'Febrero' },
        { id: 3, text: 'Marzo' },
        { id: 4, text: 'Abril' },
        { id: 5, text: 'Mayo' },
        { id: 6, text: 'Junio' },
        { id: 7, text: 'Julio' },
        { id: 8, text: 'Agosto' },
        { id: 9, text: 'Septiembre' },
        { id: 10, text: 'Octubre' },
        { id: 11, text: 'Noviembre' },
        { id: 12, text: 'Diciembre' },
      ],
      unidades: [],
      filtros: {
        gestion: null,
        mes: null,
        unidad: null,
      },
      omit_filtro: false,
      agruparOtrosIngresos: true,
    };
  },
  // components: { AAsignacionTablaRtxs },
  watch: {
    'filtros.gestion': function () {
      if (this.filtros.gestion) this.listarsignaciones();
    },
    'filtros.mes': function () {
      if (this.filtros.mes) this.listarsignaciones();
    },
    'filtros.unidad': function () {
      if (this.filtros.unidad) this.listarsignaciones();
    },
    omit_filtro: function () {
      //this.resetcache();
      this.listarsignaciones();
    },
    agruparOtrosIngresos: function () {
      //this.resetcache();
      this.listarsignaciones();
    },
  },
  methods: {
    tableToExcel(table, name) {
      if (!table.nodeType) table = this.$refs.table;
      var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
      var link = document.createElement('a');
      link.download = 'REPORTE_RECAUDACION_TOTAL_POR_SEDE.xls';
      link.href = this.uri + this.base64(this.format(this.template, ctx));
      link.click();
    },
    getMontoCelda(recaudaciones, recibo, concepto, estado) {
      window.console.log('>>> getMontoCelda', recaudaciones, recibo, concepto, estado);
      const conceptoID = concepto.split('|')[1];
      const rec = recaudaciones.find(r =>
        r.concepto_pago_id_recibos == conceptoID
      );

      if (!rec) return '0.00';

      const pago = rec.pagos.find(p =>
        p.recibos_asignacion === recibo &&
        p.recibos_estado_asignacion === estado
      );

      return pago ? this.parsecomas(pago.monto) : '0.00';
    },

    // getMontoOtrosIngresos(recaudaciones) {
    //   const totalOtrosIngresos = recaudaciones.reduce((total, item) => {
    //     const sumaPagos = item.pagos
    //       .filter(p => p.recibos_asignacion === 'otros ingresos')
    //       .reduce((sum, p) => sum + Number(p.monto), 0)

    //     return total + sumaPagos
    //   }, 0)

    //   return totalOtrosIngresos? this.parsecomas(totalOtrosIngresos) : '0.00' ;

    //   //return totalOtrosIngresos.toFixed(2)
    // },

    getMontoOtrosIngresos(recaudaciones) {
  if (!Array.isArray(recaudaciones)) return '0.00'

  const totalOtrosIngresos = recaudaciones.reduce((total, item) => {
    if (!Array.isArray(item.pagos)) return total

    const sumaPagos = item.pagos
      .filter(p => p.recibos_asignacion === 'otros ingresos')
      .reduce((sum, p) => sum + Number(p.monto || 0), 0)

    return total + sumaPagos
  }, 0)

  return totalOtrosIngresos > 0
    ? this.parsecomas(totalOtrosIngresos)
    : '0.00'
},

    parsecomas(numero) {
      if (numero === null || numero === undefined) return '0.00';

      // Aseguramos que sea un número
      const n = Number(numero);
      if (isNaN(n)) return '0.00';

      // Formateamos con comas y 2 decimales
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    getMontoTotalOtrosIngresos(){
      let total = 0;

      this.structuredData.forEach(row => {
        row.recaudaciones.forEach(r => {
          r.pagos.forEach(p => {
            if (p.recibos_asignacion === 'otros ingresos') {
              total += Number(p.monto);
            }
          });
        });
      });

      return this.parsecomas(total);
    },



    getTotalColumna(recibo, concepto, estado) {
      let total = 0;
      const conceptoID = concepto.split('|')[1];

      this.structuredData.forEach(row => {
        const rec = row.recaudaciones.find(r =>
          r.concepto_pago_id_recibos == conceptoID
        );

        if (!rec) return;

        const pago = rec.pagos.find(p =>
          p.recibos_asignacion === recibo &&
          p.recibos_estado_asignacion === estado
        );

        if (pago) total += Number(pago.monto);
      });

      return this.parsecomas(total);
    },

    

    getTotalConcepto(recaudaciones, recibo, concepto) {
      const conceptoID = concepto.split('|')[1];
      const rec = recaudaciones.find(r => r.concepto_pago_id_recibos == conceptoID);
      if (!rec) return '0.00';
      const total = rec.pagos
        .filter(p => p.recibos_asignacion === recibo)
        .reduce((sum, p) => sum + Number(p.monto || 0), 0);
      return this.parsecomas(total);
    },

    getTotalConceptoColumna(recibo, concepto) {
      const conceptoID = concepto.split('|')[1];
      let total = 0;
      this.structuredData.forEach(row => {
        const rec = row.recaudaciones.find(r => r.concepto_pago_id_recibos == conceptoID);
        if (!rec) return;
        rec.pagos
          .filter(p => p.recibos_asignacion === recibo)
          .forEach(p => { total += Number(p.monto || 0); });
      });
      return this.parsecomas(total);
    },

    getTotalFila(recaudaciones) {
      let total = 0;

      recaudaciones.forEach(r => {
        r.pagos.forEach(p => {
          total += Number(p.monto);
        });
      });

      return this.parsecomas(total);
    },




    getHeader(data) {
      const grupos = {};

      data.forEach(item => {
        const key = item.recibos_asignacion;

        if (!grupos[key]) {
          grupos[key] = {
            recibo_asignacion: key,
            estados: new Set(),
            conceptosSet: new Set(),
            lengthLevel1: 0,
            lengthLevel2: 0,
            items: []
          };
        }

        const grupo = grupos[key];
        grupo.estados.add(item.recibos_estado_asignacion);
        grupo.conceptosSet.add(`${item.concepto_pago_recibos}|${item.concepto_pago_id_recibos}`);

        grupo.items.push(item);
      });

      const headers = Object.values(grupos).map(grupo => {
        const estadosArray = Array.from(grupo.estados);
        const conceptosArray = Array.from(grupo.conceptosSet).map(concepto => ({
          concepto: concepto,
          estado_recibos_asignacion: estadosArray
        }));

        return {
          recibo_asignacion: grupo.recibo_asignacion,
          conceptos: conceptosArray,
          estados: estadosArray,
          lengthLevel1: estadosArray.length * conceptosArray.length,
          lengthLevel2: estadosArray.length,
          total_items: grupo.items.length,
          items: grupo.items // Mantener los items para procesamiento
        };
      });

      return headers;
    },

    listarsignaciones() {
      if (!this.filtros.gestion) return;
      if (!this.filtros.mes) return;
      if (!this.filtros.unidad) return;
      let anio = this.filtros.gestion;
      let mes = this.filtros.mes.id;
      let unidad = this.filtros.unidad.id;
      if (this.loading) return;
      this.loading = true;
      let convenio = 0;
      if (this.$store.state.convenio && !this.omit_filtro) convenio = this.$store.state.convenio.id;
      let urla = `${process.env.VUE_APP_API_REST}/api/v8/recaudacion/sede?month=${mes}&year=${anio}&sede_id=${unidad}&universidad_id=${convenio}`;
      xaxios.get(urla)
        .then(response => {
          const flatData = response.data.data;

          this.structuredData = this.transformData(flatData);
          this.headersData = this.getHeader(flatData);

          window.console.log("Headers:", this.headersData);
          window.console.log("Transformed Data:", this.structuredData);
          this.loading = false;
        })
        .catch(err => {
          window.console.error("Error loading data:", err);
          this.loading = false;
        });

      // fetch('/JsonRecaudacion.json')
      //   .then(r => r.json())
      //   .then(json => {
      //     const flatData = json.data;
      //     this.structuredData = this.transformData(flatData);
      //     this.headersData = this.getHeader(flatData);

      //     window.console.log("Headers:", this.headersData);
      //     window.console.log("Transformed Data:", this.structuredData);

      //     //renderOriginalTable(structuredData);
      //   })
      //   .catch(err => window.console.error("Error loading data:", err));
    },

    transformData(flatData) {
      const programasMap = {};

      flatData.forEach(item => {
        const progId = item.programa_id;

        if (!programasMap[progId]) {
          programasMap[progId] = {
            sede: {
              unidad_negocio_id: item.unidad_negocio_id,
              sede_id: item.sede_id,
              nombre_sede: item.nombre_sede,
              programa_id: item.programa_id,
              nombre_compuesto: item.nombre_compuesto,
              total_monto: 0
            },
            recaudaciones: []
          };
        }

        const prog = programasMap[progId];
        const conceptoNombre = item.concepto_pago_recibos;
        const conceptoId = item.concepto_pago_id_recibos;

        let recaudacion = prog.recaudaciones.find(r => r.concepto_pago_id_recibos === conceptoId);
        if (!recaudacion) {
          recaudacion = {
            concepto_pago_id_recibos: conceptoId,
            concepto_pago_recibos: conceptoNombre,
            pagos: []
          };
          prog.recaudaciones.push(recaudacion);
        }


        recaudacion.pagos.push({
          recibos_asignacion: item.recibos_asignacion,
          recibos_estado_asignacion: item.recibos_estado_asignacion,
          monto: item.monto
        });
      });

      return Object.values(programasMap);
    },

    // listarsignaciones() {
    //   // if (!this.filtros.gestion) return;
    //   // if (!this.filtros.mes) return;
    //   // if (!this.filtros.unidad) return;
    //   // let anio = this.filtros.gestion;
    //   // let mes = this.filtros.mes.id;
    //   // let unidad = this.filtros.unidad.id;
    //   // if (this.loading) return;
    //   // this.loading = true;
    //   // let convenio = 0;
    //   // if (this.$store.state.convenio && !this.omit_filtro) convenio = this.$store.state.convenio.id;
    //   // this.$refs.asignacionestablar.obtenerasignaciones(mes, anio, unidad, convenio);
    // },
    async getunidades() {
      var vue = this;
      this.filtros.unidad = null;
      this.loadingunidades = true;
      var sql = gql`
          query {
            getSedes {
              id
              nombre
            }
          }
        `;
      await this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          var dat = data.data.getSedes;
          dat.map((x) => {
            x.text = x.nombre;
          });
          vue.unidades = dat;
          vue.loadingunidades = false;
          let unidad = vue.$store.state.CARGO.sede.id;
          vue.filtros.unidad = dat.find((u) => u.id == unidad);
          //window.console.log('>>> ', unidad, JSON.stringify(dat, null, 4), vue.filtros.unidad);
        })
        .catch((error) => {
          vue.loadingunidades = false;
          window.console.error(error);
        });
    },
    defaultdata() {
      let date = new Date();
      let anio = date.getFullYear();
      let mes = date.getMonth() + 1;
      this.filtros.gestion = '' + anio;
      this.filtros.mes = this.meses.find((x) => x.id == mes);
    },
    dataloaded() {
      this.loading = false;
    },
  },
  mounted() {
    this.defaultdata();
    // this.getDataRecaudacion();
    this.listarsignaciones();
    this.getunidades();

  },
};
</script>
